import { __callbacks } from "Utils/Callbacks/Callback";
import { ChatMessageFragment } from "Utils/Chats/ChatMessageFragment";
import { Chat } from "Utils/Enums";
import { __map } from "Utils/Map/Map";
import { __utils } from "Utils/Utils";
import { useCallback, useEffect, useState } from "react";
import styles from "./Form.module.scss";
import { __sb } from "Utils/SB/sb";
import DynamicForm from 'dynamic-form-json';

var firstUpdate = true;

const callbackIds = {
    onInputText: "",
    onInputEmail: "",
    onInputTerms: ""
};

export default function CustomForm(props: any) {
    const [isNameValid, setIsNameValid] = useState(false);
    const [nameValue, setNameValue] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [emailValue, setEmailValue] = useState("");
    const [isCheckBox, setIsCheckBox] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [submit, setSubmit] = useState(props.submit ?? false);

    const handleFormUpdate = useCallback(() => {
        if (props.local && firstUpdate) {
            firstUpdate = false;
            return;
        }

        const fragmentNo = props.fragmentNo ?? __map.getFragmentNoFromId(props.id);

        __callbacks.formUpdate.trigger({
            type: Chat.Fragment,
            data: new ChatMessageFragment({
                id: __utils.getUuidv4(),
                chatId: props.conversationId,
                messageNo: props.messageNo,
                messageType: props.messageType,
                fragmentType: "CustomForm",
                time: Date.now(),
                props: {
                    id: props.id,
                    conversationId: props.conversationId,
                    messageNo: props.messageNo,
                    messageType: props.messageType,
                    name: nameValue,
                    email: emailValue,
                    checked: isCheckBox,
                    submit: submit
                }
            })
        });
    }, [props, nameValue, emailValue, isCheckBox, submit]);

    useEffect(() => {
        setTimeout(() => {
            handleFormUpdate();
        }, 1000);
    }, [handleFormUpdate]);

    useEffect(() => {
        setIsFormValid(isNameValid && isEmailValid && isCheckBox);
    }, [isNameValid, isEmailValid, isCheckBox]);

    useEffect(() => { }, [isFormValid]);

    const onSubmit = (val: any) => {
        setSubmit(true);
        alert(JSON.stringify(val, null, 4));
    };

    const formData = [
        {
            id: "name",
            label: "Full Name",
            placeholder: "full name",
            type: "text",
            validationType: "string",
            value: "",
            validations: [
                {
                    type: "required",
                    params: ["name is required"],
                },
                {
                    type: "min",
                    params: [5, "name can't be less than 5 characters"],
                },
                {
                    type: "max",
                    params: [10, "name can't be more than 10 characters"],
                },
            ],
        },
        {
            id: "photo",
            label: "Photo",
            placeholder: "",
            type: "upload",
            validationType: "string",
            value: "",
            validations: [
                {
                    type: "required",
                    params: ["photo is required"],
                },
            ],
        },
        {
            id: "email",
            label: "Email",
            placeholder: "email",
            type: "text",
            validationType: "string",
            value: "",
            validations: [
                {
                    type: "required",
                    params: ["email is required"],
                },
                {
                    type: "min",
                    params: [5, "email can't be less than 5 characters"],
                },
                {
                    type: "max",
                    params: [20, "email can't be more than 20 characters"],
                },
                {
                    type: "email",
                    params: ["please enter a valid email"],
                },
            ],
        },
        {
            id: "phone_number",
            label: "Phone Number",
            placeholder: "phone number",
            type: "text",
            validationType: "number",
            value: "",
            validations: [
                {
                    type: "required",
                    params: ["phone number is required"],
                },
            ],
        },
        {
            id: "total",
            label: "Total Family Member",
            placeholder: "total family member",
            type: "text",
            validationType: "number",
            value: "",
            validations: [
                {
                    type: "required",
                    params: ["total family's member is required"],
                },
                {
                    type: "min",
                    params: [1, "there should be at least 1 family member"],
                },
                {
                    type: "max",
                    params: [5, "max family members can be 5"],
                },
            ],
        },
        {
            id: "city",
            label: "City Address",
            placeholder: "",
            type: "select",
            validationType: "string",
            value: "",
            options: ["Batam", "Jakarta", "Bandung"],
            validations: [
                {
                    type: "required",
                    params: ["city address is required"],
                },
            ],
        },
        {
            id: "home",
            label: "Home Address",
            placeholder: "home address",
            type: "textarea",
            validationType: "string",
            value: "",
            validations: [
                {
                    type: "required",
                    params: ["home address is required"],
                },
                {
                    type: "min",
                    params: [10, "home address can't be less than 10 characters"],
                },
            ],
        },
        {
            id: "gender",
            label: "Gender",
            placeholder: "",
            type: "radio",
            validationType: "string",
            value: "",
            options: ["Male", "Female"],
            validations: [
                {
                    type: "required",
                    params: ["gender is required"],
                },
            ],
        },
        {
            id: "hobbies",
            label: "Hobbies",
            placeholder: "",
            type: "checkbox",
            validationType: "string",
            value: "",
            options: ["Playing Football", "Online Games", "Travelling"],
            validations: [
                {
                    type: "required",
                    params: ["hobbies is required"],
                },
            ],
        },
    ];

    useEffect(() => {
        if (!submit) return;

        // remove callbacks
        __callbacks.inputText.remove(callbackIds.onInputText);
        __callbacks.inputEmail.remove(callbackIds.onInputEmail);
        __callbacks.inputTerms.remove(callbackIds.onInputTerms);

    }, [submit]);

    useEffect(() => {
        callbackIds.onInputText = __callbacks.onInputText(({ isValid, value }: { isValid: boolean, value: string }) => {
            setIsNameValid(isValid);
            setNameValue(value);
            setIsCheckBox(true);
        });
        callbackIds.onInputEmail = __callbacks.onInputEmail(({ isValid, value }: { isValid: boolean, value: string }) => {
            setIsEmailValid(isValid);
            setEmailValue(value);
            setIsCheckBox(true);
        });
        //callbackIds.onInputTerms = __callbacks.onInputTerms((checked: boolean) => {
        //  setIsCheckBox(checked);
        //});
        firstUpdate = true;
    }, []);

    return (
        <div className={`${styles.container} config-msg-receive-fragment`}>
            <div className={styles["container-form"]}>
                <DynamicForm fields={formData} cbSubmit={onSubmit} />
            </div>
        </div>
    )
}
